import Page404 from '../pages/404'
import PageIndex from '../pages/index'
import PageDaIndex from '../pages/da/index'
import PageDcIndex from '../pages/dc/index'

const routes = [
  {
    name: 'index',
    path: '/',
    alias: '/index',
    props: true,
    component: PageIndex,
    meta: {
      title: '首页'
    }
  }
  // 非典藏版用户
  ,{
    name: 'da',
    path: '/da',
    props: true,
    component: PageDaIndex,
    meta: {
      title: '520版+高级股票池免费送'
    }
  }
  // 典藏版用户
  ,{
    name: 'dc',
    path: '/dc',
    props: true,
    component: PageDcIndex,
    meta: {
      title: '520版+高级股票池免费送'
    }
  },{
    name: 'dcGift',
    path: '/dc/award',
    props: true,
    component: PageDcIndex,
    meta: {
      title: '520版+高级股票池免费送'
    }
  },
  {
    name: '404',
    path: '*',
    component: Page404
  }
]

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '')
})

export default routes
